module.exports = __webpack_public_path__ + "starfish.790888107b17ffd42ac5f115f1b2c956.hashedasset.svg";


//////////////////
// WEBPACK FOOTER
// ./app/areas/authentication/SignIn/starfish.svg
// module id = 2019
// module chunks = 8